<template>
    <type-wrapper class="type-M" regular>
        <type-grid row="11" class="type-M-header">
            <type-text class="label-item" type="content" size="9" padding="0 15px 15px" @click="curIndex = index" v-for="(item, index) in showData" :class="index === curIndex ? 'label-item-active' : ''">{{ item.name }}</type-text>
        </type-grid>
        <type-grid row="11" margin class="type-M-content">
            <div class="content-container" :style="style">
                <div class="content-item" :key="index" :style="_style" v-for="(item, index) in showData">
                    <type-grid row="12" margin>
                        <type-image mode="widthFix" :src="item.photo"></type-image>
                    </type-grid>
                    <type-grid row="12" margin>
                        <!-- Display all content sections for this item -->
                        <div v-for="(section, sectionIndex) in item.sections" :key="sectionIndex" class="content-section">
                            <type-text type="title" size="1" align="left" weight="bold" v-if="section.title">{{ section.title }}</type-text>
                            <type-text type="title" size="6" align="left" weight="normal" v-if="section.subtitle">{{ section.subtitle }}</type-text>
                            <type-text type="content" size="9" :style="contentColor" v-if="section.content">{{ section.content }}</type-text>
                        </div>
                    </type-grid>
                </div>
            </div>
        </type-grid>
    </type-wrapper>
</template>

<script>
    // N分图文书签
    import mixin from '../mixin.js'
    export default {
        name: 'type-M',
        mixins: [ mixin ],
        data() {
            return {
                curIndex: 0
            }
        },
        computed: {
            // Override the mixin's showData with custom transformation
            showData() {
                console.log('=== TypeM showData computation ===');
                
                // Get raw data from mixin
                const rawData = this.typeData.data;
                console.log('Raw typeData.data:', rawData);
                
                if (!Array.isArray(rawData)) {
                    console.log('TypeM: No valid array found');
                    return [];
                }

                // Transform each item
                const transformedData = rawData.map((item, index) => {
                    console.log(`\n=== Processing TypeM Item ${index} ===`);
                    console.log('Raw item keys:', Object.keys(item));
                    
                    const transformedItem = {
                        name: item.name || '',
                        photo: item.photo || item.image || item.logo || '',
                        sections: []
                    };

                    // Parse tuwen_content if it exists
                    if (item.tuwen_content && typeof item.tuwen_content === 'string') {
                        console.log('Parsing tuwen_content for item:', index);
                        transformedItem.sections = this.parseAllContentSections(item.tuwen_content);
                    }
                    
                    // If no sections parsed from tuwen_content, use direct properties
                    if (transformedItem.sections.length === 0) {
                        console.log('No tuwen_content sections, using direct properties');
                        transformedItem.sections.push({
                            title: item.title || '',
                            subtitle: item.subtitle || '',
                            content: item.content || ''
                        });
                    }

                    console.log('Final transformed item:', transformedItem);
                    return transformedItem;
                });

                console.log('Final TypeM transformed data:', transformedData);
                return transformedData;
            },
            
            style() {
                let marginLeft = `-${this.curIndex * 100}%`;
                return `width: ${this.showData.length * 100}%;margin-left: ${marginLeft};`;
            },
            _style() {
                return `width: calc(100% / ${this.showData.length});`;
            }
        },
        
        methods: {
            parseAllContentSections(htmlContent) {
                console.log('Parsing HTML content:', htmlContent);
                
                const sections = [];
                
                try {
                    // More precise regex patterns that match exact patterns
                    const titlePattern = /(?:^|\s)title:\[([^\]]+)\]/g;
                    const subtitlePattern = /(?:^|\s)subtitle:\[([^\]]+)\]/g;
                    const contentPattern = /(?:^|\s)content:\[([^\]]+)\]/g;
                    
                    // Extract all matches
                    const titleMatches = [...htmlContent.matchAll(titlePattern)];
                    const subtitleMatches = [...htmlContent.matchAll(subtitlePattern)];
                    const contentMatches = [...htmlContent.matchAll(contentPattern)];
                    
                    console.log('Title matches:', titleMatches.map(m => m[1]));
                    console.log('Subtitle matches:', subtitleMatches.map(m => m[1]));
                    console.log('Content matches:', contentMatches.map(m => m[1]));
                    
                    // Find all positions and create sections
                    const allMatches = [];
                    
                    titleMatches.forEach(match => {
                        allMatches.push({
                            type: 'title',
                            content: match[1].trim(),
                            index: match.index
                        });
                    });
                    
                    subtitleMatches.forEach(match => {
                        allMatches.push({
                            type: 'subtitle',
                            content: match[1].trim(),
                            index: match.index
                        });
                    });
                    
                    contentMatches.forEach(match => {
                        allMatches.push({
                            type: 'content',
                            content: match[1].trim(),
                            index: match.index
                        });
                    });
                    
                    // Sort by position in text
                    allMatches.sort((a, b) => a.index - b.index);
                    
                    console.log('All matches sorted:', allMatches);
                    
                    // Group into sections
                    let currentSection = { title: '', subtitle: '', content: '' };
                    
                    allMatches.forEach(match => {
                        if (match.type === 'title') {
                            // Start new section if current has content
                            if (currentSection.title || currentSection.subtitle || currentSection.content) {
                                sections.push({ ...currentSection });
                                currentSection = { title: '', subtitle: '', content: '' };
                            }
                            currentSection.title = match.content;
                        } else if (match.type === 'subtitle') {
                            // Start new section if current has content
                            if (currentSection.title || currentSection.subtitle || currentSection.content) {
                                sections.push({ ...currentSection });
                                currentSection = { title: '', subtitle: '', content: '' };
                            }
                            currentSection.subtitle = match.content;
                        } else if (match.type === 'content') {
                            currentSection.content = match.content;
                        }
                    });
                    
                    // Add final section
                    if (currentSection.title || currentSection.subtitle || currentSection.content) {
                        sections.push(currentSection);
                    }
                    
                    console.log('Final sections:', sections);
                    
                } catch (error) {
                    console.error('Error parsing HTML content:', error);
                }
                
                return sections;
            }
        }
    }
</script>

<style scoped lang="less">
    .type-M{
        .type-M-header{
            display: flex;
            justify-content: center;
            .label-item{
                cursor: pointer;
                display: inline-flex;
                &-active{
                    border-bottom: 1px solid #41466E;
                }
            }
        }
        .type-M-content{
            overflow: hidden;
            .content-container{
                transition: margin-left 300ms linear;
                .content-item{
                    display: inline-flex;
                    flex-wrap: wrap;
                    vertical-align: top;
                    
                    .content-section {
                        margin-bottom: 15px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
</style>